<template>
  <div>
    <w-popup-show :state="state" @handleClose="handleClose">
      <div slot="content" class="use-temp-container"
           :class="bar && isIos ? 'ios-bar-temp-container' : isIos ? 'ios-use-temp-container' : ''" @touchmove.prevent
           v-if="templateInfo">
        <div class="header flex-start">
          <span class="iconfont iconx" @click="handleClose"/>
          <img class="wonder-logo" src="https://files.wondercv.com/mobile/cvs/template-logo.png" alt="">
          <div class="flex-column">
            <span class="headline">{{templateInfo.name}}</span>
            <div class="tags-wrapper flex">
              <div class="secondary" v-for="(item, index) in templateInfo.tags" :key="index">{{ item.cn }}</div>
            </div>
          </div>
        </div>
        <div class="use-temp-content" :class="bar && isIos ? 'ios-bar-temp-content' : isIos ? 'ios-temp-content' : ''">
          <cube-scroll :data="[templateInfo]" ref="scroll">
            <div class="use-temp" :class="{'ios-bar-use-temp': bar && isIos}">
              <div class="hr-message" v-if="templateInfo.hr_name">
                <p class="hr-title headline">HR 推荐</p>
                <div class="hr-info flex-start">
                  <img :src="templateInfo.hr_avatar" alt="">
                  <div class="flex-column-between hr">
                    <p class="hr-name">{{templateInfo.hr_name}}</p>
                    <p class="hr-position">{{ templateInfo.hr_position }}</p>
                  </div>
                </div>
                <p class="hr-desc" v-html="templateInfo.hr_desc"/>
              </div>
              <div class="template-info">
                <div class="template-img-wrapper flex-center">
                  <img v-if="templateInfo.img" :src="templateInfo.img" alt="" @load="loadImage">
                  <img v-else :src="currentType === 'cn' ? templateInfo.cn_img : templateInfo.en_img" alt=""
                       @load="loadImage">
                </div>
                <p class="template-desc">{{ templateInfo.desc || templateInfo.temp_desc }}</p>
              </div>
            </div>
          </cube-scroll>
        </div>
        <div class="footer use-temp-footer flex-start" :class="{'ios-use-temp-footer': isIos}"
             :style="bar && isIos ? 'bottom: 24px' : ''">
          <div class="lang-type flex-between">
            <span v-if="templateInfo.lang === 'cn' || templateInfo.lang === 'all'" class="flex-center"
                  :class="[{'active': currentType === 'cn'}, {'single-lang': templateInfo.lang === 'cn'}]"
                  @click="changeLang('cn')">中</span>
            <span v-if="templateInfo.lang === 'en' || templateInfo.lang === 'all'" class="flex-center"
                  :class="[{'active': currentType === 'En'}, {'single-lang': templateInfo.lang === 'en'}]"
                  @click="changeLang('En')">En</span>
            <div v-if="templateInfo.lang === 'all'" class="slider flex-center"
                 :class="currentType === 'cn' ? 'cn-animation' : 'en-animation'">
            </div>
          </div>
          <button class="theme-button use-btn" @click="cvByTemp">使用模板</button>
        </div>
      </div>
    </w-popup-show>
    <upper-limit-cv :state="show" @handleClose="show = false"/>
    <w-loading v-show="loadingShow" :show-text="true"/>
  </div>
</template>

<script>
	import WPopupShow from '@/components/global/w-popup-show'
	import upperLimitCv from './upper-limit-cv'
	import WLoading from '@/components/global/w-loading'
	import { loginMixin, envMixin } from '@/assets/js/mixin/global'
	import { componentsMixin } from '@/assets/js/mixin/components'
	import { userMixin } from '../../assets/js/mixin/user'

	export default {
		name: 'use-temp',
		mixins: [ loginMixin, componentsMixin, envMixin, userMixin ],
		props: {
			state: {
				type: Boolean,
				default: false
			},
			templateInfo: {
				type: Object,
				default: null
			},
			bar: {
				type: Boolean,
				default: false
			},
      isLogin: {
			  type: Boolean,
        default: false
      }
		},
		data () {
			return {
				currentType: 'cn',
				show: false,
				loadingShow: false
			}
		},
		computed: {
			currText () {
				return this.currentType === 'cn' ? '中' : 'En'
			}
		},
		watch: {
			state (val) {
				if (val) {
					this.currentType = this.templateInfo.cn_img !== '' ? 'cn' : 'en'
				}
			}
		},
		components: {
			WPopupShow,
			upperLimitCv,
			WLoading
		},
		methods: {
			loadImage () {
				this.$refs.scroll && this.$refs.scroll.refresh()
			},
			cvByTemp () {
				this.verifyLogin(this.isLogin, this.createCv, process.env.VUE_APP_HOST + this.$route.path)
			},
			async createCv () {
        this.$emit('useTemp', this.templateInfo, 'daniu')
			},
			changeLang (lang) {
				this.currentType = lang.toLowerCase()
			},
			handleClose () {
				this.$emit('handleClose')
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .use-temp-container {
    width: 100vw;
    height: 95vh;
    padding-bottom: 14px;
    position: relative;
    box-sizing: border-box;
    /*background-color: #F9F9F9;*/
    border-radius: 16px 16px 0 0;
    .header {
      border-bottom: 1px solid #f0f0f0;
      padding: 14px 0 14px 26px;
      background-color: $color-light;
      border-radius: 16px 16px 0 0;
      height: 68px;
      box-sizing: border-box;
      .iconfont {
        position: absolute;
        top: 22px;
        right: 18px;
        color: #9c9c9c;
        font-size: 20px;
      }
      .wonder-logo {
        width: 28px;
        margin-right: 12px;
      }
      .headline {
        margin-bottom: 8px;
      }
      .tags-wrapper {
        flex-wrap: wrap;
        height: 12px;
        overflow: hidden;
        max-width: 70vw;
        .secondary {
          color: #9c9c9c;
          font-size: $font-size-small;
          margin-right: 6px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
    .use-temp-content {
      height: calc(95vh - 158px);
      box-sizing: border-box;
      .use-temp {
        background-color: $color-light;
        padding: 0;
        .template-info {
          padding-top: 32px;
          .template-img-wrapper {
            border-radius: 8px;
            border: 1px solid #f0f0f0;
            margin: 0 26px 14px;
            img {
              width: 100%;
              border-radius: 8px;
            }
          }
          .template-desc {
            color: $color-light-gray;
            line-height: 22px;
            padding: 0 26px 32px;
          }
        }
        .hr-message {
          padding: 24px 26px;
          border-bottom: 12px solid #f9f9f9;
          box-sizing: border-box;
          .hr-title {
            margin-bottom: 16px;
          }
          .hr-info {
            margin-bottom: 14px;
            img {
              width: 48px;
              margin-right: 10px;
            }
            .hr {
              height: 48px;
              .hr-name {
                color: #2c343a;
              }
              .hr-position {
                font-size: $font-size-small;
                color: #b7b7b7;
              }
            }
          }
          .hr-desc {
            color: $color-light-gray;
            line-height: 24px;
          }
        }
      }
    }
    .use-temp-footer {
      width: 100vw;
      box-sizing: border-box;
      padding: 12px 16px;
      height: 90px;
      box-sizing: border-box;
      background-color: $color-light;
      @include ipx-content-bottom(24px);
      .lang-type {
        position: relative;
        background-color: #ececec;
        border-radius: 4px;
        height: 44px;
        z-index: 10;
        padding: 0 7px;
        span {
          /*display: inline-block;*/
          position: relative;
          z-index: 14;
          width: 40px;
          color: #9c9c9c;
        }
        .active {
          color: $color-title;
        }
        .single-lang {
          color: $color-title;
          font-weight: 500;
        }
        .slider {
          position: absolute;
          top: 6px;
          left: 6px;
          width: 40px;
          height: 32px;
          background-color: $color-light;
          border-radius: 4px;
          color: $color-title;
          z-index: 9;
        }
        .cn-animation {
          transform: translateX(0);
          transition: all 0.3s;
        }
        .en-animation {
          transform: translateX(100%);
          transition: all 0.3s;
        }
      }
      .use-btn {
        height: 44px;
        flex: 1;
        border-radius: 4px;
        font-weight: 500;
        font-size: $font-size-medium-x;
        margin-left: 12px;
      }
    }

    .ios-use-temp-footer {
      padding-bottom: 24px !important;
    }
  }
  .ios-use-temp-container {
    height: 85vh;
    .ios-temp-content {
      height: calc(85vh - 158px);
    }
  }
  .ios-bar-temp-container {
    height: 88vh;
    .ios-bar-temp-content {
      height: calc(88vh - 172px);
      .ios-bar-use-temp {
        padding-bottom: 34px
      }
    }
  }
</style>
